import React from 'react';
import topPattern from '../assets/img/rasta/top-pattern.jpg';
import axios from 'axios';
import {
	Form,
	Input,
	Modal,
	InputNumber,
	Button,
	Select,
	DatePicker,
	Row,
	Col,
	Typography,
	Card,
	notification,
	message,
} from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface IWard {
	student_class: string;
	student_device: 'smartphone' | 'desktop' | 'laptop';
	student_dob: string;
	student_gender: 'm' | 'f';
	student_name: string;
	program: string;
	student_school: string;
}

const Register = () => {
	const programs = [
			{
				name: 'Abacus Only (GH₵170)',
				slug: 'abacus',
				price: 170,
			},
			{
				name: 'Coding Only (GH₵150)',
				slug: 'coding',
				price: 150,
			},
			{
				name: 'French Only (GH₵100)',
				slug: 'french',
				price: 100,
			},
			{
				name: 'Abacus and Coding (GH₵230)',
				slug: 'abacus-and-coding',
				price: 230,
			},
			{
				name: 'Abacus and French (GH₵230)',
				slug: 'abacus-and-french',
				price: 230,
			},
			{
				name: 'Coding and French (GH₵160)',
				slug: 'coding-and-french',
				price: 160,
			},
			{
				name: 'Abacus, Coding and French (GH₵290)',
				slug: 'abacus-coding-and-french',
				price: 290,
			},
		],
		[parentForm] = Form.useForm(),
		[wardsForm] = Form.useForm(),
		[numKids, setNumKids] = React.useState(0),
		[loading, setLoading] = React.useState(false),
		[parent, setParent] = React.useState<any>(),
		handleParentFormSubmit = async (payload: Record<string, any>) => {
			setLoading(true);
			const hide = message.loading('Validating your information', 0);
			try {
				console.log('payload', payload);
				await axios.post('pre.php', payload);

				setNumKids(payload.kids_count);
				setParent(payload);
				notification.success({
					message: 'Validated',
					description: 'Enter your ward details to complete the registration',
				});
			} catch (e) {
				console.log('e', e);
				notification.error({
					message: 'Failed',
					description:
						'Please contact us for support on 0205003933 / 0558740741',
				});
			} finally {
				setLoading(false);
				hide();
			}
		},
		handleWardsFormSubmit = async (payload: Record<string, any>) => {
			setLoading(true);
			const hide = message.loading('Submitting ward(s) information', 0);
			try {
				console.log('payload', payload, parentForm.getFieldsValue());
				const res = await axios.post('lg.php', {
					wards: payload.wards.map((w: IWard) => ({
						...w,
						// program: w.program,
						...parent,
					})),
				});

				if (res.data !== 'success') {
					throw `Registration failed. Response: ${JSON.stringify(res)}`;
					return;
				}

				console.log(
					'lopit',
					payload.wards.map(
						(ward: IWard) => programs.find(p => ward.program == p.slug)?.price,
					),
				);

				Modal.success({
					closable: false,
					title: 'Submited',
					okText: 'Exit',
					onOk: () => (window.location.href = '/'),
					content: `Registration complete, your total is: ${payload.wards
						.map(
							(ward: IWard) =>
								programs.find(p => ward.program == p.slug)?.price,
						)
						.reduce((acc: any, curr: any) => (acc += curr), 0)}`,
				});
			} catch (e) {
				console.log('e', e);
				notification.error({
					message: 'Failed',
					description:
						'Please contact us for support on 0205003933 / 0558740741',
				});
			} finally {
				setLoading(false);
				hide();
			}
		};

	return (
		<section id="smt-form">
			<div className="form-hol container">
				{!numKids ? (
					<Form
						form={parentForm}
						layout="vertical"
						onFinish={handleParentFormSubmit}
					>
						<div className="top-pattern">
							<h2 className="smt-hd">Fill The Form Below To Register</h2>
						</div>
						<Typography.Title level={4} style={{ fontSize: '18px' }}>
							Parent Information
						</Typography.Title>

						<Row gutter={[12, 12]}>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							></Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
							>
								<Form.Item
									name="parent_name"
									label="Parent Name"
									rules={[
										{
											required: true,
											message: 'The Parent Name field is required',
										},
									]}
								>
									<Input />
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="parent_contacts"
									label="Phone / Whatsapp"
									rules={[
										{
											required: true,
											message: 'The Phone / Whatsapp field is required',
										},
									]}
								>
									<Input />
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="parent_email"
									label="Email"
									rules={[
										{ required: true, message: 'The Email field is required' },
									]}
								>
									<Input type="email" />
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="parent_city"
									label="City"
									rules={[
										{ required: true, message: 'The City field is required' },
									]}
								>
									<Input />
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="parent_region"
									label="Region"
									rules={[
										{ required: true, message: 'The Region field is required' },
									]}
								>
									<Select>
										<Select.Option value="Greater Accra Region">
											Greater Accra Region
										</Select.Option>
										<Select.Option value="Ashanti Region">
											Ashanti Region
										</Select.Option>
										<Select.Option value="Central Region">
											Central Region
										</Select.Option>
										<Select.Option value="Eastern Region">
											Eastern Region
										</Select.Option>
										<Select.Option value="Western Region">
											Western Region
										</Select.Option>
										<Select.Option value="Volta Region">
											Volta Region
										</Select.Option>
										<Select.Option value="Northern Region">
											Northern Region
										</Select.Option>
										<Select.Option value="Upper East Region">
											Upper East Region
										</Select.Option>
										<Select.Option value="Upper West Region">
											Upper West Region
										</Select.Option>
										<Select.Option value="Western North Region">
											Western North Region
										</Select.Option>
										<Select.Option value="Savannah Region">
											Savannah Region
										</Select.Option>
										<Select.Option value="North East Region">
											North East Region
										</Select.Option>
										<Select.Option value="Bono Region">
											Bono Region
										</Select.Option>
										<Select.Option value="Ahafo Region">
											Ahafo Region
										</Select.Option>
										<Select.Option value="Bono East Region">
											Bono East Region
										</Select.Option>
										<Select.Option value="Oti Region">Oti Region</Select.Option>
									</Select>
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="parent_religion"
									label="Religion"
									rules={[
										{
											required: true,
											message: 'The Religion field is required',
										},
									]}
								>
									<Input />
								</Form.Item>
							</Col>

							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
							>
								<Form.Item
									name="kids_count"
									label="How many kids will you be registering?"
									rules={[
										{
											required: true,
											message:
												'Please enter the number of kids you will be registering',
										},
									]}
								>
									<InputNumber style={{ width: '100%' }} />
								</Form.Item>
							</Col>
						</Row>
						<Form.Item style={{ textAlign: 'center' }}>
							<button type="submit" className="smt-btn bg1 white-text">
								Click To Proceed <i className="fas fa-paper-plane"></i>
							</button>
						</Form.Item>
					</Form>
				) : (
					<Form
						form={wardsForm}
						layout="vertical"
						onFinish={handleWardsFormSubmit}
					>
						<div className="top-pattern">
							<h2 className="smt-hd">Fill The Form Below To Register</h2>
						</div>

						<Typography.Title level={4} style={{ fontSize: '18px' }}>
							Wards Information
						</Typography.Title>

						<Form.List name="wards" initialValue={Array.from(Array(numKids))}>
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Card
											size="small"
											key={key}
											style={{ marginBottom: 12, borderColor: 'orange' }}
											title={
												<p style={{ textAlign: 'right', margin: 0 }}>
													<Button
														danger
														onClick={() => remove(name)}
														icon={<MinusCircleOutlined />}
													>
														Remove Ward
													</Button>
												</p>
											}
										>
											<Row gutter={[12, 12]}>
												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_name']}
														label="Student Name"
														rules={[
															{
																required: true,
																message: 'Missing Student Name',
															},
														]}
													>
														<Input placeholder="Student Name" />
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_dob']}
														label="Date of Birth"
														rules={[
															{
																required: true,
																message: 'Missing Date of Birth',
															},
														]}
													>
														<DatePicker
															format="DD/MM/YYYY"
															style={{ width: '100%' }}
														/>
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_school']}
														label="Student School"
														rules={[
															{
																required: true,
																message: 'Missing Student School',
															},
														]}
													>
														<Input placeholder="Student School" />
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_class']}
														label="Student Class"
														rules={[
															{
																required: true,
																message: 'Missing Student Class',
															},
														]}
													>
														<Input placeholder="Student Class" />
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_device']}
														label="Student Device"
														rules={[
															{
																required: true,
																message: 'Missing Student Device',
															},
														]}
													>
														<Select
															style={{ width: '100%' }}
															placeholder="Select device"
														>
															<Select.Option value="smartphone">
																Smart Phone
															</Select.Option>
															<Select.Option value="laptop">
																Laptop
															</Select.Option>
															<Select.Option value="desktop">
																Desktop
															</Select.Option>
														</Select>
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'student_gender']}
														label="Student Gender"
														rules={[
															{
																required: true,
																message: 'Missing Student Gender',
															},
														]}
													>
														<Select
															style={{ width: '100%' }}
															placeholder="Select gender"
														>
															<Select.Option value="m">Male</Select.Option>
															<Select.Option value="f">Female</Select.Option>
														</Select>
													</Form.Item>
												</Col>

												<Col
													xs={{ span: 24 }}
													sm={{ span: 24 }}
													md={{ span: 12 }}
													lg={{ span: 12 }}
												>
													<Form.Item
														{...restField}
														name={[name, 'program']}
														label="Student Program"
														rules={[
															{
																required: true,
																message: 'Missing Student Program',
															},
														]}
													>
														<Select
															style={{ width: '100%' }}
															placeholder="Select program"
														>
															{programs.map(p => (
																<Select.Option key={p.slug} value={p.slug}>
																	{p.name}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
											</Row>
										</Card>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={() => add()}
											block
											icon={<PlusOutlined />}
										>
											Add another ward
										</Button>
									</Form.Item>
								</>
							)}
						</Form.List>

						<Form.Item style={{ textAlign: 'center' }}>
							<button
								type="submit"
								disabled={loading}
								className="smt-btn bg1 white-text"
							>
								Submit Details <i className="fas fa-paper-plane"></i>
							</button>
						</Form.Item>
					</Form>
				)}
			</div>
		</section>
	);
};

export default Register;
